import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import {
  ContentAnalysisV2Scope,
  ContentTopicsBy,
} from 'src/services/contentAnalysisApi/interfaces/contentAnalysisV2.interface'
import { ContentAnalysisV2ApiService } from 'src/services/contentAnalysisV2Api'

interface TopicDetailParams {
  by: ContentTopicsBy
  limit: number
  // The topic, or the subtopic when `parent` is set.
  name: string | null
  page: number
  parent?: string | null
}

export const useGetContentAnalysisTopicDetailQuery = (
  scope: ContentAnalysisV2Scope,
  { by, limit, name, page, parent }: TopicDetailParams
) =>
  useQuery({
    enabled: !!name,
    // Keeps the current related items on screen while the next page loads;
    // the modal checks the answer matches the view before drawing it.
    placeholderData: keepPreviousData,
    queryFn: () =>
      ContentAnalysisV2ApiService.getTopicDetail(scope, {
        by,
        limit,
        name: name as string,
        page,
        parent: parent || undefined,
      }),
    queryKey: [
      QueryKey.GET_CONTENT_ANALYSIS_TOPIC_DETAIL,
      by,
      name,
      parent,
      page,
      limit,
      scope.analysisIds?.join(','),
      scope.from,
      scope.to,
      scope.period,
      scope.platform,
    ],
  })
